import(/* webpackMode: "eager" */ "/tmp/claude-1000/-home-tresno-projects/6a75db9f-cce6-424a-8f84-9edf2de2e863/scratchpad/wi-build/app/global-error.tsx");
